import React from 'react';
import ReactDOM from 'react-dom';
import styles from './Modal.module.css';

const butterfly = require('../../assets/icons/butterfly.svg').default;
const trail = require('../../assets/images/butterfly-trail.svg').default;

export default function Modal({
  children, showBar = true, maxWidth = 600, borderRadius = '10px',
  backgroundColor = 'white',
}) {
  return ReactDOM.createPortal(
    (
      <div className={styles.backdrop}>
        <div className={styles.modal} style={{ maxWidth, borderRadius }}>
          { showBar && (
            <div className={styles.modalBar}>
              <img src={trail} alt="" />
              <img src={butterfly} alt="" />
            </div>
          ) }
          <div className={styles.content} style={{ backgroundColor, borderRadius }}>{children}</div>
        </div>
      </div>
    ), document.body,
  );
}
